import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import WorkSlider from "@/components/site/WorkSlider";

export default function Work() {
  return (
    <div data-testid="work-page">
      {/* ── HEADER ── */}
      <section className="border-b border-zinc-900 px-5 md:px-10 pt-12 pb-10 overflow-hidden">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF1111]">
          Selected work • Pune
        </p>
        <h1
          className="font-display uppercase leading-[1.05] mt-4 break-words"
          style={{ fontSize: "clamp(2rem, 5.5vw, 7rem)" }}
        >
          CAMPAIGNS, CONTENT,
          <br />
          IDENTITY — BUILT TO LAND.
        </h1>
        <p className="mt-5 max-w-3xl font-grotesk text-base md:text-lg text-zinc-700 leading-relaxed">
          A selection of projects shaped through strategy, creativity, and thoughtful execution.
        </p>
      </section>

      {/* ── WORK SLIDER ── */}
      <WorkSlider />

    </div>
  );
}
